import { render, staticRenderFns } from "./Locations.html?vue&type=template&id=06b3d270&external"
import script from "./Locations.js?vue&type=script&lang=js&external"
export * from "./Locations.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports